import { Button, InfoBadge, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../hooks/navigation";
import { useTracker } from "../hooks/useTracker";
import useTranslation from "../hooks/useTranslation";
import { ElementClickAction, ElementClickLocation } from "../lib/TrackingAdapter";

export const PaddleBillingPaymentSuccessPage: React.FC = () => {
  const { t, m } = useTranslation();
  const navigation = useNavigation();
  const tracker = useTracker();

  return (
    <InfoPage
      variant="success"
      title={t(m.PaddleBillingPaymentSuccessPage.Title)}
      description={t(m.PaddleBillingPaymentSuccessPage.Description)}
      primaryCTA={
        <Button
          onClick={() => {
            tracker.trackButtonClick({
              action: ElementClickAction.GO_TO_DOWNLOAD,
              location: ElementClickLocation.CHECKOUT_SUCCESS_NON_RECURRING,
            });
            navigation.goToDownloadPage();
          }}
        >
          {t(m.PaddleBillingPaymentSuccessPage.DownloadCTA)}
        </Button>
      }
      footer={
        <InfoBadge
          standalone={true}
          description={t(m.PaddleBillingPaymentSuccessPage.AlreadyInstalled)}
          cta={
            <Button
              variant="grayscale"
              onClick={() => {
                tracker.trackButtonClick({
                  action: ElementClickAction.OPEN_SHAPR,
                  location: ElementClickLocation.CHECKOUT_SUCCESS_NON_RECURRING,
                });
                navigation.goToShaprApp({ autoOpen: false });
              }}
            >
              {t(m.PaddleBillingPaymentSuccessPage.OpenApp)}
            </Button>
          }
        />
      }
    />
  );
};
